/**
 * Um domicílio fiscal declarado pelo cliente.
 *
 * É uma LISTA no cliente, não um registro único: FATCA e CRS exigem declarar
 * TODAS as residências fiscais, e residência dupla é comum entre os PF
 * estrangeiros que a mesa atende. O formato antigo (`taxDomicileAbroadCountry`
 * + `taxDomicileAbroadIdentification`, um par solto em `additional`) só
 * comportava uma.
 */
export default class CustomerTaxDomicileModel {
  constructor(obj) {
    obj = obj || {};

    this.id = obj.id;
    /* Código ISO, mesma convenção do CountryField. */
    this.country = obj.country || '';
    this.documentTypeId = obj.documentTypeId || null;
    this.documentNumber = obj.documentNumber || '';
  }
}
